export default function () {
  var array = this._array;
  this._array = null;
  return Promise.resolve(array ? {
    done: false,
    value: array
  } : {
    done: true,
    value: undefined
  });
}